import type { PGD } from "../types";

export const pgdFluticasoneSinusitis: PGD = {
  id: "pgd-6a-fluticasone-sinusitis",
  reference: "6a",
  version: "1.0",
  drugRef: "fluticasone_furoate_nasal_spray",
  indication: "Acute sinusitis — intranasal corticosteroid treatment",
  validFrom: "2024-01-31",
  expiryDate: "2027-01-30",
  frameworkType: "pharmacy_first",
  population: {
    ageRange: { min: 12, max: 999 },
    pregnancyAllowed: false,
    breastfeedingAllowed: false,
  },
  duration: { days: 14 },
  doseBands: [
    {
      id: "fluticasone-age12plus",
      resolveBy: "single",
      ageRange: { min: 12, max: 999 },
      dose: "2 sprays into each nostril",
      frequency: "ONCE daily",
      formulations: [
        {
          formulationId: "flut-furoate-27.5mcg-spray",
          instruction: "Use TWO sprays into EACH nostril ONCE daily for 14 days",
          quantity: { count: 1, label: "1 nasal spray" },
        },
      ],
    },
  ],
  preSupplyChecks: [
    { id: "ex-consent-refused", question: "Has the patient/carer refused consent?" },
    { id: "ex-pregnant", question: "Is the patient pregnant or suspected pregnant?" },
    { id: "ex-breastfeeding", question: "Is the patient breastfeeding?" },
    { id: "ex-allergy", question: "Known hypersensitivity to fluticasone furoate or any excipients?" },
    { id: "ex-nasal-trauma", question: "Recent nasal surgery, nasal trauma, or unhealed nasal ulceration?" },
    { id: "ex-nasal-infection", question: "Untreated localised infection involving the nasal mucosa?" },
    { id: "ex-recent-steroid", question: "Already using an intranasal corticosteroid for this episode?" },
    { id: "ex-systemic-steroid", question: "Currently taking systemic corticosteroids or potent CYP3A4 inhibitors?" },
  ],
  cautions: [
    { id: "caution-epistaxis", text: "Advise to stop and seek advice if significant nasal bleeding occurs." },
    { id: "caution-technique", text: "Check nasal spray technique and avoid spraying directly onto the nasal septum." },
  ],
  counselling: [
    "Use regularly once daily for the full course",
    "Shake well before use and prime if needed",
    "Aim the spray slightly outwards, away from the nasal septum",
    "Seek advice if symptoms worsen rapidly or significantly",
  ],
  counsellingPoints: [
    { text: "Use regularly once daily for the full course" },
    { text: "Shake well before use and prime if needed" },
    { text: "Aim the spray slightly outwards, away from the nasal septum" },
    { text: "Seek advice if symptoms worsen rapidly or significantly" },
  ],
  outcomeLinkRefs: ["nhs-sinusitis", "target-rti-leaflet"],
};
